module.exports = __webpack_public_path__ + "img/aim.3883669b.svg";